module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img39.917ae7e7.jpg";